import React, { useState, useEffect } from "react";

import ScreenOne from "../prReportOverall/index.jsx";
import { lazy, Suspense } from "react";
import { withRouter } from "react-router-dom";
import Loader from "../../../../../utilityComponents/Loader";
import { Button, Grid } from "@material-ui/core";
import  * as Constants  from "../../../cm_shared/Reporting/constants.jsx"
const ScreenTwo = lazy(() => import("../prReportScenario/index.jsx"));
const ScreenThree = lazy(() => import("../prReportVariation/index.jsx"));

const searchOption = (pageParams,modeType,pageValue) => {
  const modeStr=modeType?`mode=${modeType}&&`:null
  switch (pageParams.reporting_level.toUpperCase()) {
    case Constants.TESTRUNID:
      return `test_run_id=${pageParams.test_run_id.trim()}&&reporting_level=${pageParams.reporting_level.trim()}&&execution_id=${pageParams.execution_id.trim()}&&${pageValues(
        pageValue
      )}`;
    case Constants.EXECUTIONID:
      if(modeStr)
        return `${modeStr}reporting_level=${pageParams.reporting_level.trim()}&&execution_id=${pageParams.execution_id.trim()}&&${pageValues(
          pageValue
        )}`;
      else
        return `reporting_level=${pageParams.reporting_level.trim()}&&execution_id=${pageParams.execution_id.trim()}&&${pageValues(
          pageValue
        )}`; 
    
  }
};

const pageValues = (pageValue) => {
  return pageValue.reduce((stringValues, value, index) => {
    let pageStr = `&&pageValue=${value}`;
    if (index == 0) pageStr = `pageValue=${value}`;
    return stringValues + pageStr;
  }, "");
};
const compareStrings = (str1, str2) => {
  return str1.localeCompare(str2, undefined, { sensitivity: "base" }) === 0;
};
const MainPage = (props) => {
  const [screenTwoData, setScreenTwoData] = useState(null);
  const [screenThreeData, setScreenThreeData] = useState(null);
  const [querParamHolder, setquerParamHolder] = useState(null);
  const { pageType } = props.match.params;
  useEffect(() => {
    const queryparams = new URLSearchParams(window.location.search);
    const executionId = queryparams.get("execution_id");
    const testRunId = queryparams.get("test_run_id");
    const reportingLevel = queryparams.get("reporting_level");
    const pageValue = queryparams.getAll("pageValue");
    const modeType = queryparams.get("mode");
    setquerParamHolder({
      pageParam: {
        execution_id: executionId,
        test_run_id: testRunId,
        reporting_level: reportingLevel,
        modeType
      },
    });
    if (compareStrings(pageType, Constants.SCENARIO))
      setScreenTwoData({ filterby: pageValue[0] });
    if (compareStrings(pageType, Constants.VARIATION))
      setScreenThreeData({ filename: pageValue[0], result: pageValue[1],region:pageValue[2],vehicleId:pageValue[3] });
  }, [pageType]);

  const cleanUp = (pageType) => {
    switch (pageType.toUpperCase()) {
      case Constants.SCENARIO:
        setScreenTwoData(null);
        break;
      case Constants.VARIATION:
        setScreenThreeData(null);
        break;
    }
  };

  const handlePage = (pageType, pageValue) => {
    switch (pageType.toUpperCase()) {
      case Constants.SCENARIO:
        props.history.push({
          pathname: `/PR_Report_Screen/scenario`,
          search: searchOption(querParamHolder.pageParam,querParamHolder.pageParam.modeType,pageValue),
        });
        break;
      case Constants.VARIATION:
        props.history.push({
          pathname: `/PR_Report_Screen/variation`,
          search: searchOption(querParamHolder.pageParam,querParamHolder.pageParam.modeType,pageValue),
        });
        break;
    }
  };

  if (querParamHolder && compareStrings(pageType, Constants.OVERALL))
    return (
      <ScreenOne
        {...querParamHolder}
        handlePage={(...pageValues) =>
          handlePage(Constants.SCENARIO, pageValues)
        }
      />
    );

  return (
    <div style={{ padding: "30px" }}>
      <Grid container spacing={3}>
        <Grid item xs={5}>
          <Button
            onClick={() => {
              props.history.goBack();
            }}
            variant="contained"
            style={{ backgroundColor: "rgb(98, 42, 216)", color: "white" }}
          >
            Back
          </Button>
        </Grid>
      </Grid>
      {compareStrings(pageType, Constants.SCENARIO) &&
      <Suspense fallback={<Loader/>}>
        { querParamHolder &&
          screenTwoData && <ScreenTwo
              {...querParamHolder}
              {...screenTwoData}
              handlePage={(...pageValues) =>
                handlePage(Constants.VARIATION, pageValues)
              }
              cleanUp={() => cleanUp(Constants.SCENARIO)}
            />
          }
        </Suspense>
        }

        {compareStrings(pageType, Constants.VARIATION) && 
        <Suspense fallback={<Loader/>}>
        {querParamHolder &&
          screenThreeData &&
         <ScreenThree
              {...querParamHolder}
              {...screenThreeData}
              cleanUp={() => cleanUp(Constants.VARIATION)}
            />
          }
      </Suspense>
        }
    </div>
  );
};

export default withRouter(MainPage);